export const COMPANY_INFO = {
  brandName: 'SUNMARBELLA',
  legalName: 'SIASOL MARBELLA SL',
  taxId: 'B93243665',
  registry: 'Registro Mercantil de Malaga, tomo 5109, folio 203, inscripcion 1, hoja MA-117166',
  websiteUrl: 'https://sunmarbella.com',
  email: 'hello@sunmarbella.com',
  emailHref: 'mailto:hello@sunmarbella.com',
  phone: '+34 851 000 158',
  phoneHref: 'tel:+34851000158',
  whatsappNumber: '34851000158',
  address: {
    line1: 'Calle Jacinto Benavente, 16 local 20 - 313',
    line2: 'Marbella, Spain 29602',
    streetAddress: 'Calle Jacinto Benavente, 16 local 20 - 313',
    locality: 'Marbella',
    region: 'Malaga',
    postalCode: '29602',
    country: 'Spain',
    countryCode: 'ES',
  },
} as const;

export const LEGAL_LAST_UPDATED = 'April 5, 2026';

export function buildWhatsAppUrl(message?: string): string {
  const baseUrl = `https://wa.me/${COMPANY_INFO.whatsappNumber}`;

  if (!message) {
    return baseUrl;
  }

  return `${baseUrl}?text=${encodeURIComponent(message)}`;
}
